import { trackEvent } from "./index";

/**
 * Product events for the new UI, named `v2_<area>_<action>`, so the old and new UI can be compared.
 * Every event already carries `ui_version` and `projectId`.
 */
export function trackV2(event: `v2_${string}`, data: Record<string, unknown> = {}) {
    trackEvent(event, data);
}
